import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./bento-theme.css";
import { applyTheme, applyUiTheme, getThemeMode, watchSystemTheme } from "./lib/theme";
import { getUiTheme } from "./lib/app-prefs";
import { installGlobalErrorHandlers } from "./lib/error-log";

// Capture uncaught errors / rejections into the in-app log (Settings → Nhật ký lỗi).
installGlobalErrorHandlers();

// D39: Apply theme BEFORE React renders to prevent flash-of-light-mode.
const initialMode = getThemeMode();
applyTheme(initialMode);

// Initialize UI layout theme
const initialUiTheme = getUiTheme();
applyUiTheme(initialUiTheme);

// Re-apply on OS scheme changes — but only while the STORED mode is "system",
// re-checked at fire time so manual Sáng/Tối picks are never overridden and
// switching to "system" later still tracks the OS without a reload.
watchSystemTheme(() => {
  if (getThemeMode() === "system") {
    applyTheme("system");
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    const version = encodeURIComponent(import.meta.env.VITE_APP_VERSION ?? import.meta.env.MODE);
    void navigator.serviceWorker.register(`/sw.js?version=${version}`);
  });
}
